"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _clientAuth = require("@devsta/client-auth"),
    _uiKit = require("@devsta/ui-kit"),
    _getValueFromGenericInput = require("@devsta/get-value-from-generic-input"),
    _classnames = _interopRequireDefault(require("classnames")),
    _ContentLoader = _interopRequireDefault(require("../../../../ContentLoader")),
    _utils = require("../../../utils");

require("../styles/_collaborators-list.scss");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var CollaboratorsList = function (_Component) {
  function CollaboratorsList(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, CollaboratorsList), _this = _super.call(this, props), _this.getSelectedRoleDescription = function (roleName) {
      var _this$props$roles = _this.props.roles,
          roles = void 0 === _this$props$roles ? [] : _this$props$roles,
          selectedRole = roles.find(function (_ref) {
        var name = _ref.name;
        return name === roleName;
      });
      return selectedRole ? selectedRole.description : "";
    }, _this.getEmptyText = function () {
      var _this$props = _this.props,
          listItems = _this$props.listItems,
          type = _this$props.type;
      return listItems ? "No ".concat(type, " found") : "Search for the ".concat(type, " that you want to add as Collaborators");
    }, _this.handleButtonClick = function (item, index) {
      return function () {
        var onAddMember = _this.props.onAddMember;
        onAddMember && _this.setState(function (_ref2) {
          var prevAddedIndexes = _ref2.addedIndexes,
              addedIndexes = [].concat((0, _toConsumableArray2["default"])(prevAddedIndexes), [index]);
          return {
            addedIndexes: addedIndexes
          };
        }, function () {
          onAddMember(item);
        });
      };
    }, _this.changeAccessPermission = function (index, item) {
      return function (result) {
        var _this$props2 = _this.props,
            onUpdateMember = _this$props2.onUpdateMember,
            _this$props2$roles = _this$props2.roles,
            roles = void 0 === _this$props2$roles ? [] : _this$props2$roles;

        if (onUpdateMember) {
          var selectedRole = roles.find(function (_ref3) {
            var description = _ref3.description;
            return description === (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result);
          }),
              updatedItem = _objectSpread({}, item, {
            role: selectedRole
          });

          onUpdateMember(index, updatedItem);
        }
      };
    }, _this.renderContentLoader = function () {
      return _react["default"].createElement("div", {
        className: "collaborators-list__loading"
      }, _react["default"].createElement(_ContentLoader["default"], {
        height: 100,
        width: 100
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        rx: "2",
        ry: "2",
        width: "20",
        height: "30"
      }), _react["default"].createElement("rect", {
        x: "22",
        y: "6",
        rx: "2",
        ry: "2",
        width: "78",
        height: "5"
      }), _react["default"].createElement("rect", {
        x: "22",
        y: "18",
        rx: "2",
        ry: "2",
        width: "78",
        height: "5"
      })));
    }, _this.state = {
      addedIndexes: []
    }, _this;
  }

  (0, _inherits2["default"])(CollaboratorsList, _Component);

  var _super = _createSuper(CollaboratorsList);

  return (0, _createClass2["default"])(CollaboratorsList, [{
    key: "renderListItem",
    value: function renderListItem(_ref4) {
      var item = _ref4.item,
          onRemoveMember = _ref4.onRemoveMember,
          index = _ref4.index,
          _ref4$membersIds = _ref4.membersIds,
          membersIds = void 0 === _ref4$membersIds ? [] : _ref4$membersIds,
          currentUserId = _ref4.currentUserId,
          _this$props3 = this.props,
          type = _this$props3.type,
          _this$props3$roles = _this$props3.roles,
          roles = void 0 === _this$props3$roles ? [] : _this$props3$roles,
          isMembersTab = "members" === type,
          userId = item.userId,
          teamId = item.teamId,
          imageUrl = item.imageUrl,
          firstName = item.firstName,
          lastName = item.lastName,
          name = item.name,
          _item$email = item.email,
          email = void 0 === _item$email ? "" : _item$email,
          role = item.role,
          teamMembers = item.teamMembers,
          displayName = name || "".concat(firstName, " ").concat(lastName);
      return _react["default"].createElement(_react.Fragment, {
        key: userId || teamId
      }, _react["default"].createElement("div", {
        className: "collaborators-list__item"
      }, _react["default"].createElement(_uiKit.Image, {
        imageUrl: imageUrl,
        placeholderText: displayName,
        width: "75px",
        height: "75px"
      }), _react["default"].createElement("div", {
        className: "collaborators-list__item__info"
      }, _react["default"].createElement("p", {
        className: "collaborators-list__item__info__primary"
      }, "".concat(displayName).concat(userId === currentUserId ? " (you)" : "")), _react["default"].createElement("p", {
        className: "collaborators-list__item__info__secondary"
      }, userId ? email : "MEMBERS: ".concat(teamMembers ? teamMembers.length : 0))), _react["default"].createElement("div", {
        className: (0, _classnames["default"])("collaborators-list__item__right-container", {
          "collaborators-list__item__right-container__add": !isMembersTab
        })
      }, isMembersTab ? _react["default"].createElement(_uiKit.Dropdown, {
        className: "collaborators-list__item__right-container__role-dropdown",
        type: "BASIC",
        onChange: this.changeAccessPermission(index, item),
        defaultValue: this.getSelectedRoleDescription(role.name),
        options: (0, _utils.getRolesForDisplay)(roles).map(function (_ref5) {
          var description = _ref5.description;
          return description;
        }),
        disabled: isMembersTab && 0 === index
      }) : _react["default"].createElement(_uiKit.Button, {
        className: "collaborators-list__item__right-container__button",
        onClick: this.handleButtonClick(item, index),
        type: "PRIMARY",
        small: !0,
        disabled: membersIds.includes(userId || teamId)
      }, membersIds.includes(userId || teamId) ? "ADDED" : "ADD ".concat("users" === type ? "USER" : "TEAM")), isMembersTab ? _react["default"].createElement(_uiKit.Icon, {
        name: "close",
        size: 15,
        onClick: onRemoveMember(index),
        className: (0, _classnames["default"])("collaborators-list__item__right-container__remove-icon", {
          "collaborators-list__item__right-container__remove-icon--hidden": 0 === index
        }),
        color: "nevada"
      }) : null)), _react["default"].createElement("hr", {
        className: "collaborators-list__horizontal-line"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props4 = this.props,
          listItems = _this$props4.listItems,
          onRemoveMember = _this$props4.onRemoveMember,
          type = _this$props4.type,
          membersIds = _this$props4.membersIds,
          loading = _this$props4.loading;

      if (loading) return this.renderContentLoader();

      var _credentials$get = _clientAuth.credentials.get(),
          _credentials$get$user = _credentials$get.user;

      _credentials$get$user = void 0 === _credentials$get$user ? {} : _credentials$get$user;
      var _credentials$get$user2 = _credentials$get$user.userId,
          currentUserId = void 0 === _credentials$get$user2 ? "" : _credentials$get$user2;
      return _react["default"].createElement("div", {
        className: "collaborators-list"
      }, listItems && listItems.length ? listItems.map(function (item, index) {
        return _this2.renderListItem({
          item: item,
          index: index,
          onRemoveMember: onRemoveMember,
          type: type,
          membersIds: membersIds,
          currentUserId: currentUserId
        });
      }) : _react["default"].createElement("div", {
        className: "collaborators-list__empty"
      }, _react["default"].createElement("p", {
        className: "collaborators-list__empty__text"
      }, this.getEmptyText())));
    }
  }]), CollaboratorsList;
}(_react.Component),
    _default = CollaboratorsList;

exports["default"] = _default;